import { render } from "./ArticleManagement.vue?vue&type=template&id=583fbe2b"
import script from "./ArticleManagement.vue?vue&type=script&lang=js"
export * from "./ArticleManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__